import { Grid2 } from "@mui/material";
import React from "react";
import FormToggleButtonGroup from "../../../../component/form/FormToggleButtonGroup";
import FormTelInput from "../../../../component/form/FormTelInput";
import FormTextField from "../../../../component/form/FormTextField";

export default function AssistantInfo({ control, watch }) {
  const hasAssistant = watch("hasAssistant");
  const deviceType = watch("deviceType");
  const hasClinicDevice = deviceType === "clinic" || deviceType === "both";
  //   console.log("has assistant = ", hasAssistant);
  return (
    <>
      <Grid2 size={{ xs: 12 }}>
        <FormToggleButtonGroup
          fieldname="deviceType"
          control={control}
          label="Which EKKO device do you have?"
          required
          exclusive
          defaultValue=""
          sx={{ maxWidth: 480 }}
          options={[
            { label: "EKKO Portable", value: "portable" },
            { label: "EKKO Clinic", value: "clinic" },
            { label: "Both", value: "both" },
          ]}
        />
      </Grid2>
      {hasClinicDevice && (
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <FormTextField
            placeholder="EKKO Clinic device ID"
            label="EKKO Clinic device ID"
            fieldname="clinicDeviceId"
            control={control}
            required
            rules={{
              validate: (value) =>
                value.trim() !== "" || "This field is required",
            }}
          />
        </Grid2>
      )}
      <Grid2 size={{ xs: 12 }}>
        <FormToggleButtonGroup
          fieldname="hasAssistant"
          control={control}
          label="Do you have an assistant?"
          required
          exclusive
          defaultValue=""
          sx={{ maxWidth: 240 }}
          options={[
            { label: "Yes", value: "Yes" },
            { label: "No", value: "No" },
          ]}
        />
      </Grid2>
      {hasAssistant === "Yes" && (
        <>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormTextField
              placeholder="Assistant's name"
              label="Assistant's name"
              fieldname="assistantName"
              control={control}
              required
              onlyText
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormTelInput
              label="Assistant's phone no"
              fieldname="assistantPhoneNumber"
              required
              control={control}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, lg: 6 }}>
            <FormTextField
              placeholder="Assistant's email address"
              label="Assistant's email"
              fieldname="assistantEmail"
              control={control}
              required
              rules={{
                pattern: {
                  value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
                  message: "Invalid email",
                },
              }}
            />
          </Grid2>
        </>
      )}
    </>
  );
}
